
export default function HeroSection({ onContactClick }: { onContactClick: () => void }) {
  const bookingUrl = 'https://www.housecallpro.com/book/Blue-Team-Carpet--Dryer-Vent-Cleaning?company=80c78a4651b14af9b1112d122f1ff5d3';

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/981dc544bfd36d7da5898dbe85ba97db.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Professional Carpet & Dryer Vent Cleaning in <strong>Escondido</strong>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            Serving San Diego County since 1994 with eco-friendly steam cleaning services. 
            Same day service available for residential and commercial properties.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Book Your Cleaning Today
            </a>
            
            <a 
              href="tel:+16197482446"
              className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer flex items-center"
            >
              <i className="fa fa-phone mr-2"></i>
              Call (619) 748-2446
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-teal-600 rounded-full">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">30+ Years Experience</h3>
              <p className="text-gray-200">Trusted carpet cleaning experts since 1994</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-teal-600 rounded-full">
                <i className="ri-leaf-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Eco-Friendly Products</h3>
              <p className="text-gray-200">Safe for families, pets, and the environment</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-teal-600 rounded-full">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Same Day Service</h3>
              <p className="text-gray-200">Quick response for urgent cleaning needs</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
